import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";

import { useAuth } from "@vega-api/custom/api/hooks/useAuth";
import { type FrontendPortal } from "@vega-api/generated/types/frontendPortal";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { isLocalSession } from "@vega-core/utils/global";

import { CommonPaths } from "../../paths";
import { LocalSessionLogoutButton } from "../LocalLogin/LocalSessionLogoutButton";

export const LogoutRoute = ({ source }: { source: FrontendPortal }) => {
  const navigate = useNavigate();
  const { isLoading, logout, unknownError } = useAuth();
  const logoutInitiatedRef = useRef(false);

  useEffect(() => {
    if (isLocalSession) return;

    if (!isLoading && !logoutInitiatedRef.current) {
      logoutInitiatedRef.current = true;
      logout({
        isGlobal: true,
        savePath: false,
        source: source,
      });
    }
  }, [isLoading, logout, source]);

  useEffect(() => {
    if (unknownError && !isLoading) {
      navigate(CommonPaths.Login);
    }
  }, [unknownError, isLoading, navigate]);

  if (isLocalSession) {
    return (
      <div className="flex items-center justify-center min-h-screen p-6">
        <div className="w-full max-w-sm">
          <LocalSessionLogoutButton />
        </div>
      </div>
    );
  }

  return <LoadingSpinner />;
};
